import { render, staticRenderFns } from "./CompanyRoot.vue?vue&type=template&id=2901ddc8&scoped=true"
import script from "./CompanyRoot.vue?vue&type=script&lang=ts"
export * from "./CompanyRoot.vue?vue&type=script&lang=ts"
import style0 from "./CompanyRoot.vue?vue&type=style&index=0&id=2901ddc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2901ddc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
